import React,{useEffect,useState} from 'react'
import { Link } from 'react-router-dom'
import { fetchTopSellingProducts } from '../services/nonAuthRequets'
import ProductListThree from './ProductListThree'
import ProductCards from './ProductCards'
const TrendingCustom = () => {
const [products, setProducts] = useState([]);
const [loading, setLoading] = useState(true);
useEffect(() => {
  setLoading(true);
    const fetchProducts = async () => {
        try {
          const data = await fetchTopSellingProducts();
          setProducts((prevProducts) => {
            const updatedProducts = [...prevProducts, ...data.content];
            return Array.from(
              new Map(updatedProducts.map((p) => [p.id, p])).values()
            );
          }); // Append new products
        //  console.log(data);
          setLoading(false);
        } catch (error) {
          console.error("Error searching products:", error);
          setLoading(false);  
        } finally {
          setLoading(false);
        }
      };
        fetchProducts();
}, [])

if (loading) return  <p>Loading products...</p>;
    return (
        <section className="trending-products pt-20">
            
                {/* <div className="border border-gray-100 p-24 rounded-16"> */}
                    {/* <div className="section-heading mb-24"> */}
                        {/* <div className="flex-between flex-wrap gap-8"> */}
                            <h5 className="mb-0">Trending Products</h5>
                            <ProductCards
                            products={products}
                            showLoadmore={false}
                            />
                            {/* <ProductListThree products={products} /> */}
                       
                    {/* </div>
                </div>
            </div> */}
        </section>

    )
}

export default TrendingCustom